import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getEnrollmentCourses: ['campus', 'career', 'plan', 'prog', 'period'],
  getEnrollmentCoursesClear: null,
  getEnrollmentCoursesRequest: null,
  getEnrollmentCoursesSuccess: null,
  getEnrollmentCoursesFailure: ['error']
});

export { Creators, Types };
